import Vue from "vue"
import { Prop, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component({})
/**
 * 图片轨道
 */
export default class ImgTrack extends Vue {
  @Prop({ default: [] })
  imgList: Array<IImgItem>
  @Prop({ default: {} })
  curSelect: any
  @Prop({ default: false })
  colorful: Boolean
  /**
   * 图片轨道点击
   * @param item
   * @param index 
   */
  trackImgClick(item, index) {
    this.$emit('track-img-click', item, index)
  }
}